import {
    Component,
    OnInit,
    ViewEncapsulation,
    HostListener,
    ElementRef
} from '@angular/core';
import { Router } from '@angular/router';
import { Helpers } from '../../../../../../helpers';
import { BaseComponent } from '../../../base.component';
import { Reservation } from '../../../../../../models/reservation';
import { DataService } from '../../../../../../_services/data.service';
import { ReservationService } from '../../../../../../services/reservation.service';
import { AdUnitService } from '../../../../../../services/adunit.service';
import {
    SelectService,
    SelectEvent
} from '../../../../../../_services/select.service';
import { DatatableService } from '../../../../../../_services/datatable.service';
import { LoadingService } from '../../../../../../_services/loading.service';
import {
    DatepickerService,
    Days
} from '../../../../../../_services/datepicker.service';
import { ReservationDetail } from '../../../../../../models/reservation-detail';
import { AdUnit } from '../../../../../../models/adunit';
import { ExcelService } from '../../../../../../_services/excel.sevice';
import { SiteService } from '../../../../../../services/site.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
    selector: 'app-reservation-calendar',
    templateUrl: './reservation-calendar.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ReservationCalendarComponent extends BaseComponent
    implements OnInit {
    model: Reservation = new Reservation();
    adUnits: any[] = [];
    adUnitsList: any[] = [];
    allAdUnitsIds: any[] = [];
    selectedAdUnits: any[] = [];
    selectedSiteId: any;
    filteredAdUnits: any[] = [];
    selectedAgency: any;
    selectedCustomer: any;
    calendarSearchTargetKey: string = '';
    updateVisible: boolean = false;
    selectedReservationId: string;
    calendarDatatableVisible: boolean = false;
    portlet: any;
    calendarDatatableSource: any[] = [];
    tableData: any[] = [];
    selectedDates: any[] = [];
    httpClient: any;
    siteLists: any[] = [];

    constructor(
        private reservationService: ReservationService,
        private adUnitService: AdUnitService,
        private dataService: DataService,
        private selectService: SelectService,
        private datatableService: DatatableService,
        private loading: LoadingService,
        private el: ElementRef,
        private datepickerService: DatepickerService,
        private excelService: ExcelService,
        private router: Router,
        private siteService: SiteService,
        protected http: HttpClient,
    ) {
        super();
        this.router.routeReuseStrategy.shouldReuseRoute = function() {
            return false;
        };
        this.model.publisherId = this.dataService.publisherId;
    }
    ngOnInit() {
        var self = this;
        this.loadDatatablePortlet();
        this.selectService
            .init({
                url: '/sites/list?filterId=' + this.model.publisherId,
                controlId: 'calendarSiteId',
                displayProperty: 'title'
            })
            .on(SelectEvent.select, function(e) {
                self.selectedSiteId = e.params.data.id;
                self.getTargets();
            });
        this.selectService
            .init({
                url: '/customers/list?filterId=' + this.model.publisherId,
                controlId: 'calendarCustomerId',
                displayProperty: 'name',
                allowClear: true
            })
            .on(SelectEvent.select, function(e) {
                self.selectedCustomer = e.params.data.id;
            })
            .on(SelectEvent.unselect, function(e) {
                self.selectedCustomer = null;
            });
        this.selectService
            .init({
                url: '/agencies/list?filterId=' + this.model.publisherId,
                controlId: 'calendarAgencyId',
                displayProperty: 'name',
                allowClear: true
            })
            .on(SelectEvent.select, function(e) {
                self.selectedAgency = e.params.data.id;
            })
            .on(SelectEvent.unselect, function(e) {
                self.selectedAgency = null;
            });

        var calendarDatePicker = this.datepickerService.init('calendarDatePicker', {
            multiSelectDays: true,
            multiSelectWeek: true
        });
        calendarDatePicker.onChangeDate(function() { });


    }

    selectAllSites() {
        var url = '/sites/list?filterId=' + this.model.publisherId;
        var token = Helpers.getAccessToken();
        var apiEndpoint = Helpers.getApiEndpoint();
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        });
        var URL = apiEndpoint + url;
        this.http.get<any>(URL, { headers: headers }).subscribe(res => {
            this.siteLists = res.data;
            this.siteLists.forEach(element => {
                //console.log(element.id);
                this.adUnitService.listBySiteId(element.id).subscribe(res => {
                    this.adUnitsList = res.data;
                    this.adUnitsList.forEach(element => {
                        //this.selectedAdUnits.push(element);
                        this.onTargetSelect(element);
                    });
                });
            });
            console.log(this.allAdUnitsIds);
        });
    }

    addAdUnit() {
        var text = document.getElementById('addButton').textContent;
        if (text == '+') {
            document.getElementById('addButton').textContent = '-';
        } else {
            document.getElementById('addButton').textContent = '+';
        }
    }

    onTargetSelect(adUnit) {
        adUnit.dateCount = 0;
        this.selectedAdUnits.push(adUnit);
        this.selectedAdUnits.sort(function(a, b) {
            var nameA = a.page.name + '/' + a.title;
            var nameB = b.page.name + '/' + b.title;
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        setTimeout(() => { }, 50);

        this.loadFilteredAdUnits();
        (<any>$('#calendarSelectedTargetScrollBar')).mCustomScrollbar({
            axis: 'yx',
            advanced: { autoExpandHorizontalScroll: true },
            mouseWheel: { scrollAmount: 50 }
        });
    }
    calendarSearchTarget(event) {
        this.calendarSearchTargetKey = event.target.value.toLowerCase();
        this.loadFilteredAdUnits();
    }
    loadFilteredAdUnits() {
        var self = this;
        this.filteredAdUnits = this.adUnits.filter(function(a) {
            var selectedAdUnit = self.selectedAdUnits.filter(function(s) {
                return s.id == a.id;
            });
            return (
                selectedAdUnit.length == 0 &&
                (self.calendarSearchTargetKey == '' ||
                    a.title.toLowerCase().includes(self.calendarSearchTargetKey) ||
                    a.page.name.toLowerCase().includes(self.calendarSearchTargetKey))
            );
        });
        this.filteredAdUnits.sort(function(a, b) {
            var nameA = a.page.name + '/' + a.title;
            var nameB = b.page.name + '/' + b.title;
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    }

    onSelectedTargetSelect(adUnit) {
        this.selectedAdUnits = this.selectedAdUnits.filter(function(obj) {
            return obj.id !== adUnit.id;
        });
        this.loadFilteredAdUnits();
    }

    selectAllTarget(Items) {
        Items.forEach(element => {
            this.onTargetSelect(element);
        });
    }

    clearAllTargetSelect(selectedItems) {
        this.selectedAdUnits = [];
        this.loadFilteredAdUnits();
    }
    getTargets() {
        var self = this;
        self.adUnits = [];
        this.loading.show();
        this.adUnitService.listBySiteId(this.selectedSiteId).subscribe(res => {
            self.adUnits = res.data;
            this.calendarSearchTargetKey = '';
            this.loadFilteredAdUnits();
            (<any>$('#calendarTargetScrollBar')).mCustomScrollbar({
                axis: 'yx',
                advanced: { autoExpandHorizontalScroll: true },
                mouseWheel: { scrollAmount: 50 }
            });
            this.loading.hide();
        });
    }

    searchCalendarData() {
        this.calendarDatatableVisible = true;
        this.selectedDates = this.datepickerService.getDates('calendarDatePicker');
        this.selectedDates = this.selectedDates.sort((a, b) => a - b);
        var adUnitIds = this.selectedAdUnits.map(adUnit => adUnit.id);
        if (adUnitIds.length == 0) {
            this.filteredAdUnits.forEach(element => {
                //   adUnitIds.push(element.id);  
                this.onTargetSelect(element);
            });
        }
        this.loading.show();
        this.reservationService
            .reservationDetailSearch({
                dates: this.selectedDates,
                adUnitIds: adUnitIds,
                agencyId: this.selectedAgency,
                customerId: this.selectedCustomer
            })
            .subscribe(res => {
                if (!res.data) {
                    res.data = this.filteredAdUnits;
                }
                this.calendarDatatableSource = this.getDatatableRows(
                    res.data,
                    this.selectedDates
                );
                this.loadCalendarDatatable(
                    this.calendarDatatableSource,
                    this.selectedDates
                );
                this.loading.hide();
            });
    }

    getCalendarColumns(dates: Date[]) {
        var columns = [
            {
                field: 'adUnit.title',
                title: '',
                width: 300,
                template: function(row) {
                    var rowCity = "";
                    if (row.adUnitDates.length > 0) {
                        row.adUnitDates[0].reservation.reservationCities.length > 0 ? rowCity = "<span class='m-badge m-badge--danger m-badge--wide'>City</span>" : ""
                    }
                    return (
                        '<div style="word-wrap:break-word"><strong>' +
                        row.adUnit.page.site.title +
                        '/' +
                        row.adUnit.page.name +
                        '/' +
                        row.adUnit.title +
                        ' ' +
                        rowCity +
                        '</strong></div>'
                    );
                }
            }
        ];
        for (let i = 0; i < dates.length; i++) {
            const date = dates[i];
            var isWeekend = (date.getDay() === 6) || (date.getDay() === 0);
            var column = {
                field: date.toDateString(),
                title: date.toDateString(),
                isWeekend: isWeekend,
                width: 150,
                textAlign: 'center',
                template: function(row) {
                    var cellReservationCustomerValue = '';
                    var cellReservationCityValue = '';
                    var cellReservationName = '';
                    var cellReservationAgencyValue = '';
                    var cellReservationCitiesName = '';
                    var cellbadgecolor = '';
                    if (!row.adUnitDates)
                        return '<div style="height:130px!important"></div>';
                    var selectedAdUnitDates = row.adUnitDates.filter(
                        item => date.toDateString() == new Date(item.date).toDateString()
                    );
                    if (selectedAdUnitDates.length > 0) {
                        var selectedAdUnitDate = selectedAdUnitDates[0];
                        var reservationCities =
                            selectedAdUnitDate.reservation.reservationCities;
                        cellReservationCustomerValue =
                            selectedAdUnitDate.reservation.customer.name;
                        cellReservationAgencyValue =
                            selectedAdUnitDate.reservation.agency != null ? selectedAdUnitDate.reservation.agency.name : "";

                        if (reservationCities.length > 0) {
                            var cityNames = reservationCities.map(item => item.city.name);
                            cellReservationCitiesName = cityNames.join(',');

                            cellReservationCityValue = 'City';
                            cellbadgecolor =
                                '<div><span class="m-badge m-badge--danger m-badge--wide">City</span></div>';
                        } else {
                            cellReservationCityValue = 'Turkey';
                            cellReservationCitiesName = 'All';
                        }
                        cellReservationName = selectedAdUnitDate.reservation.name;
                        var popoverId =
                            selectedAdUnitDate.reservation.id +
                            '-' +
                            row.adUnit.id +
                            '-' +
                            selectedAdUnitDate.id;
                        var dataContent =
                            '<div><br/><strong>Reservation City: </strong>' +
                            cellReservationCitiesName +
                            '</div><div><br/><strong> Agency: </strong>' +
                            cellReservationAgencyValue +
                            '</div><div><br/><strong> Customer: </strong>' +
                            cellReservationCustomerValue +
                            '</div>';

                        var popoverContent =
                            '<div id="' +
                            popoverId +
                            '" style="display: none;"><div class="popover-heading" >' +
                            cellReservationName +
                            '</div>' +
                            '<div class="popover-body">' +
                            dataContent +
                            '</div></div>';

                        return (
                            popoverContent +
                            '<div class="m-alert m-alert--icon m-alert--square alert alert-dismissible fade show" role = "alert" style="margin-bottom:0px !important">' +
                            '<div class="m-alert__text">' +
                            '<div style="padding-bottom:7px">' +
                            cellReservationCustomerValue +
                            '</div>' +
                            cellbadgecolor +
                            '<div><button type="button" data-id="' +
                            selectedAdUnitDate.reservation.id +
                            '" id="popover-edit' +
                            popoverId +
                            '" class="popover-edit btn m-btn--pill btn-link" data-trigger="hover" data-toggle="m-popover" data-container="body" data-placement="left" data-popover-content="#' +
                            popoverId +
                            '">' +
                            'Details' +
                            '</button></div>' +
                            '</div>' +
                            '<div class="m-alert__close" ><button' +
                            ' id= "delete-date' +
                            selectedAdUnitDate.id +
                            '"data-id="' +
                            selectedAdUnitDate.id +
                            '"type="button" class="delete-date close" data - dismiss="alert" aria - label="Close"></button>' +
                            '</div></div>'
                        );
                    }

                    return '<div style="height:130px!important"></div>';
                }
            };
            columns.push(column);
        }
        return columns;
    }
    loadCalendarDatatable(data, dates) {
        var columns = this.getCalendarColumns(dates);
        this.datatableService
            .setConfig({
                selectorId: 'calendarDatatable',
                columns: columns,
                localData: data,
                tableClass: 'table table-bordered',
                pagination: false
            })
            .build();
        (<any>$('[data-toggle="m-popover"]')).popover({
            html: true,
            content: function() {
                var content = $(this).attr('data-popover-content');
                return $(content)
                    .children('.popover-body')
                    .html();
            },
            title: function() {
                var title = $(this).attr('data-popover-content');
                return $(title)
                    .children('.popover-heading')
                    .html();
            }
        });
    }

    getDatatableRows(reservationDetails, dates) {
        var self = this;
        var helper = {};
        var results = reservationDetails.reduce(function(r, o) {
            if (
                self.selectedAdUnits.length < 1 ||
                self.selectedAdUnits.filter(a => a.id == o.adUnitId).length > 0
            ) {
                var key =
                    o.adUnitId +
                    '-' +
                    self.getDatatableRowCities(o.reservation.reservationCities).join('-');
                if (!helper[key]) {
                    helper[key] = Object.assign(
                        {},
                        {
                            adUnit: o.adUnit,
                            adUnitDates: o.reservationDetailDates.map(x => {
                                return { id: x.id, date: x.date, reservation: o.reservation };
                            })
                        }
                    );
                    r.push(helper[key]);
                } else {
                    for (let i = 0; i < o.reservationDetailDates.length; i++) {
                        const reservationDetailDate = o.reservationDetailDates[i];
                        helper[key].adUnitDates.push({
                            id: reservationDetailDate.id,
                            date: reservationDetailDate.date,
                            reservation: o.reservation
                        });
                    }
                }
            }
            return r;
        }, []);
        var rows = [];
        for (let i = 0; i < results.length; i++) {
            const result = results[i];
            var stop = false;
            for (let k = 0; k < dates.length && !stop; k++) {
                const date = dates[k];
                var selectedDates = result.adUnitDates.filter(
                    item => date.toDateString() == new Date(item.date).toDateString()
                );
                if (selectedDates.length > 0) {
                    rows.push(result);
                    stop = true;
                }
            }
        }
        if (self.selectedAdUnits.length > 0) {
            for (let i = 0; i < this.selectedAdUnits.length; i++) {
                const selectedAdUnit = this.selectedAdUnits[i];
                var hasAdUnit = false;
                for (let i = 0; i < rows.length; i++) {
                    const row = rows[i];
                    if (row.adUnit.id == selectedAdUnit.id) hasAdUnit = true;
                }

                if (!hasAdUnit) {
                    var adUnit = new AdUnit();
                    adUnit = selectedAdUnit;
                    rows.push({ adUnit: adUnit, adUnitDates: [] });
                }
            }
        }
        return rows;
    }

    getDatatableRowCities(reservationCities) {
        if (reservationCities == null) return [];
        var result = reservationCities.map(function(reservationCity) {
            return reservationCity.city.name;
        });
        return result;
    }

    activateUpdate(reservationid) {
        (<any>$('#datatablePortlet')).mPortlet().unFullscreen();
        this.updateVisible = true;
        this.selectedReservationId = reservationid;
    }
    activateCalendar() {
        this.updateVisible = false;
        this.selectedReservationId = null;
        this.searchCalendarData();
    }

    deleteReservationDetailDate(id) {
        this.swalService.confirmDelete().then(res => {
            if (res.value) {
                this.loading.show();
                this.reservationService
                    .deleteReservationDetailDate(id)
                    .subscribe(res => {
                        this.swalService.success('Reservation Date successfully deleted.');
                        this.searchCalendarData();
                        this.loading.hide();
                    });
            }
        });
    }

    @HostListener('click', ['$event'])
    onClick() {
        var self = this;
        this.datatableService.onClick(
            event,
            self.el,
            function(id) {
                self.activateUpdate(id);
            },
            'popover-edit'
        );
        this.datatableService.onClick(
            event,
            self.el,
            function(id) {
                self.deleteReservationDetailDate(id);
            },
            'delete-date'
        );
    }
    loadDatatablePortlet() {
        var portlet = (<any>$('#datatablePortlet')).mPortlet();
        portlet.on('afterFullscreenOn', function(portlet) {
            var scrollable = portlet.getBody().find('> .m-scrollable');

            scrollable.data('original-height', scrollable.data('max-height'));
            scrollable.css('height', '100%');
            scrollable.css('max-height', '100%');
            scrollable.mCustomScrollbar({
                scrollInertia: 0,
                autoDraggerLength: true,
                autoHideScrollbar: true,
                autoExpandScrollbar: false,
                alwaysShowScrollbar: 0,
                axis: scrollable.data('axis') ? scrollable.data('axis') : 'y',
                mouseWheel: {
                    scrollAmount: 120,
                    preventDefault: true
                },
                setHeight: '',
                theme: 'minimal-dark'
            });
        });

        portlet.on('afterFullscreenOff', function(portlet) {
            var scrollable = portlet.getBody().find('> .m-scrollable');

            scrollable.css('height', scrollable.data('original-height'));
            scrollable.data('max-height', scrollable.data('original-height'));
            scrollable.mCustomScrollbar({
                scrollInertia: 0,
                autoDraggerLength: true,
                autoHideScrollbar: true,
                autoExpandScrollbar: false,
                alwaysShowScrollbar: 0,
                axis: scrollable.data('axis') ? scrollable.data('axis') : 'y',
                mouseWheel: {
                    scrollAmount: 120,
                    preventDefault: true
                },
                setHeight: '',
                theme: 'minimal-dark'
            });
        });
    }
    datatablePortletFullScreenOff(portlet) {
        var scrollable = portlet.getBody().find('> .m-scrollable');

        scrollable.css('height', scrollable.data('original-height'));
        scrollable.data('max-height', scrollable.data('original-height'));
        scrollable.mCustomScrollbar({
            scrollInertia: 0,
            autoDraggerLength: true,
            autoHideScrollbar: true,
            autoExpandScrollbar: false,
            alwaysShowScrollbar: 0,
            axis: scrollable.data('axis') ? scrollable.data('axis') : 'y',
            mouseWheel: {
                scrollAmount: 120,
                preventDefault: true
            },
            setHeight: '',
            theme: 'minimal-dark'
        });
    }

    exportExcel(isCustomer = false) {
        var excelDataSource = [];
        var excelDataSourceName = 'ReservationList';
        if (isCustomer) excelDataSourceName = 'CustomerReservationList';
        for (let i = 0; i < this.calendarDatatableSource.length; i++) {
            const row = this.calendarDatatableSource[i];
            var isCity = false;
            var excelRow = {
                'Target Name': `${row.adUnit.page.site.title}/${row.adUnit.page.name}/${row.adUnit.title}`
            };
            for (let k = 0; k < this.selectedDates.length; k++) {
                const date = this.selectedDates[k];
                var selectedAdUnitDates = row.adUnitDates.filter(
                    item => date.toDateString() == new Date(item.date).toDateString()
                );
                if (selectedAdUnitDates.length > 0) {
                    var citiesCount =
                        selectedAdUnitDates[0].reservation.reservationCities.length;
                    var cityExcel = '';
                    if (citiesCount > 0) {
                        cityExcel = 'City';
                        isCity = true;
                    }
                    if (!isCustomer) {
                        excelRow[date.toDateString()] =
                            selectedAdUnitDates[0].reservation.customer.name +
                            '\n' +
                            selectedAdUnitDates[0].reservation.name +
                            '\n' +
                            cityExcel;
                    } else {
                        excelRow[date.toDateString()] = 'DOLU';
                    }
                } else {
                    excelRow[date.toDateString()] = '';
                }
            }
            if (isCity) {
                excelRow["Target Name"] = `${excelRow["Target Name"]} City`
            }
            excelDataSource.push(excelRow);
        }
        this.excelService.exportAsExcelFile(
            excelDataSource,
            excelDataSourceName,
            this.calendarDatatableSource.length
        );
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/reservation/reservation-calendar/reservation-calendar.component.ts